import { Modal } from "antd";

interface Props {
    visible: boolean,
    handleCancel: () => void,
    previewImage: string,
}

const ImagePreviewModal = ({ visible, handleCancel, previewImage }: Props) => {

    return (
        <Modal visible={visible} footer={null} onCancel={handleCancel} width={520}>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
                <img alt="preview" src={previewImage} style={{ width: '100%' }} />
            </div>
        </Modal>
    )
}

export default ImagePreviewModal;